import jquery from "jquery"
globalThis.$ = jquery
globalThis.jQuery = jquery